import React, { PureComponent } from "react";
import { connect } from "react-redux";
import {
  fetchTimeSheet,
  saveTimeSheet,
  exportPeriodTimeSheet,
  fetchPartners
} from "Thunks";
import {
  initTimeSheetAttachment,
  setFilterClient,
  setFilterCollaborators,
  setCycleCombination
} from "Actions";

import { onSuccess, onError } from "Utils";
import { DIALOG_TYPES, TREE_TYPES } from "../../config";
import _ from "i18n";

import {
  ICONS,
  SvgIcon,
  SimpleArrowRight,
  GarbageIcon,
  CycleIcon,
  CloseIcon
} from "../Common/Icons";
import TTPDialog from "../Common/TTPDialog";
import TTPModal from "../Common/Modal/TTPModal";
import NotFoundV2 from "../NotFound/NotFoundV2";
import PageHeader from "../Common/PageHeader/PageHeader";
import BubbleComponent from "../Common/Bubble/BubbleComponent";

import styles from "./TimeSheet.local.scss";

import CycleFactory from "../CycleFactory/CycleFactory";
import TreeTable from "../Common/Tables/TreeTable";
import TimeSheetFilter from "../TimeSheetFilter/TimeSheetFilter";
import TimeSheetUploadContent from "../TimeSheetUpload/TimeSheetUploadContent";
import { inIframe } from "../../utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";

class TimeSheetTree extends PureComponent {
  //******************   Content Functions  **************//

  intervalID;

  constructor(props) {
    super(props);

    this.state = {
      isUploadModalVisible: false,
      isConfirmationModalVisible: false,
      filterFormIsVisible: false,
      openSideBar: false,
      selectedSideBar: null,
      loading: false
    };
  }

  componentDidMount() {
    this.props.dispatch(fetchPartners());
  }

  // //******************   Content Functions END  **************//

  //******************   Content Render functions  ****************//
  renderCycleGuide = () => {
    const { combination } = this.props;
    return (
      <div
        className={styles.cycle}
        style={{ position: "relative", marginLeft: "120px" }}
      >
        <div
          className={styles.label}
          onClick={() => {
            this.setState(state => {
              return {
                openSideBar: !state.openSideBar,
                selectedSideBar: !state.openSideBar ? "indicator" : null
              };
            });
          }}
        >
          <CycleIcon /> <span>{_("cycleLabel")} : </span>
        </div>
        {combination &&
          combination
            .filter(item => item.visible === true)
            .map((item, index) => (
              <div className={styles.cellule} key={index}>
                <span>{_(item.id)}</span>
                {index < combination.length - 1 && <SimpleArrowRight />}
              </div>
            ))}
      </div>
    );
  };

  renderTimeSheet = () => {
    const { timeSheetData, erpData } = this.props;
    let dataYears, dataModel;

    dataYears = timeSheetData.periods;
    dataModel = timeSheetData.timeSheet;

    const data = dataModel ? dataModel : [];
    const columns = [
      { name: _("name"), basis: "350px", grow: "1" },
      ...(dataYears && dataYears.length > 0
        ? dataYears.map(dataYear => ({
            name: _(dataYear),
            basis: "150px",
            grow: "1"
          }))
        : [])
    ];
    return (
      <TreeTable
        expandAll={true}
        periods={dataYears}
        columns={columns}
        dataSource={data}
        erpData={erpData}
        types={[TREE_TYPES.COLLABORATOR, TREE_TYPES.CLIENT]}
        handleReOpenTree={this.handleReOpenTimeSheet.bind(this)}
      />
    );
  };

  renderTimeSheetCallout = error => {
    if (error.code === 170040) {
      return this.renderTimeSheetStillInProgress();
    } else {
      return this.renderTimeSheetNotFound(error.code);
    }
  };

  renderTimeSheetNotFound = code => {
    switch (code) {
      case 170010:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("noOrganization")}
            buttonIgnored={this.props.embedded}
          />
        );
      case 170040:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("error1")}
            buttonIgnored={this.props.embedded}
          />
        );
      case 170041:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("noTimeSheet")}
            buttonIgnored={this.props.embedded}
          />
        );

      default:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("errorOccured")}
            buttonIgnored={this.props.embedded}
          />
        );
    }
  };

  renderTimeSheetStillInProgress = () => {
    this.intervalID = setTimeout(() => {
      if (this.props.fetched) {
        clearTimeout(this.intervalID);
        return;
      }
      !this.props.fetching && this.props.dispatch(fetchTimeSheet());
    }, 7000);
    return (
      <div
        data-closable
        className={`callout alert-callout-border primary radius ${
          styles.callout
        }`}
      >
        <strong>
          <span style={{ verticalAlign: "inherit" }}>
            <img src={"/img/Spinner-1s-25px.svg"} alt="" />
          </span>
          Info
        </strong>{" "}
        <span
          dangerouslySetInnerHTML={{
            __html: _("importInProgress")
          }}
        />
        <button
          className="close-button"
          aria-label="Dismiss alert"
          type="button"
          data-close
          onClick={null}
        />
      </div>
    );
  };

  renderSideBar() {
    const { combination } = this.props;
    return (
      <div
        className={
          styles.side_bar +
          " " +
          (this.state.openSideBar
            ? styles.side_bar__opened
            : styles.side_bar__closed)
        }
      >
        {/* // TODO Content */}
        <div className={styles.side_bar__header}>
          <h5 className={styles.side_bar__header__title}>{_("cycleLabel")}</h5>
          <span>{_("dropMessage")}</span>
          <div
            className={styles.side_bar__close}
            onClick={() => {
              this.handleCloseSideBar();
            }}
          >
            <CloseIcon dimension="17" />
          </div>
        </div>
        <div className={styles.side_bar__content}>
          <CycleFactory
            dispatch={this.props.dispatch}
            combination={combination}
            handleCloseSideBar={this.handleCloseSideBar}
          />
        </div>
      </div>
    );
  }

  renderBubbles = () => {
    return (
      <ul className="bubbles">
        <li key={"range"}>
          <BubbleComponent
            bubble={{
              icon: `${
                this.state.openSideBar ? "cycle_active" : "cycle_disactive"
              }`,
              label: _("diagram"),
              className:
                this.state.openSideBar &&
                this.state.selectedSideBar === "indicator"
                  ? "bubble_activated"
                  : ""
            }}
            onClickBubble={() => {
              this.setState(state => {
                return {
                  openSideBar: !state.openSideBar,
                  selectedSideBar: !state.openSideBar ? "indicator" : null
                };
              });
            }}
          />
        </li>
      </ul>
    );
  };

  handleReOpenTimeSheet(type, id, label) {
    const { dispatch, combination } = this.props;
    let newCombination = [];
    let list = [];
    if (type === TREE_TYPES.CLIENT) {
      combination &&
        combination.forEach(item => {
          if (item.id === TREE_TYPES.CLIENT_GROUP) {
            item.visible = false;
          }
        });
      newCombination = combination.map(item => ({
        id: item.id,
        visible: item.visible
      }));
      dispatch(setCycleCombination(newCombination));
      dispatch(setFilterCollaborators([]));
      dispatch(
        setFilterClient([{ value: id, label: label, color: "#000000" }])
      );
      dispatch(fetchTimeSheet());
    } else if (type === TREE_TYPES.COLLABORATOR) {
      list = [
        TREE_TYPES.COLLABORATOR,
        TREE_TYPES.CLIENT_GROUP,
        TREE_TYPES.CLIENT,
        TREE_TYPES.TASK_TYPE
      ];
      newCombination = [];
      list &&
        list.forEach(item => {
          newCombination.push({
            id: item,
            visible: true
          });
        });
      dispatch(setCycleCombination(newCombination));
      dispatch(setFilterClient([]));
      dispatch(
        setFilterCollaborators([{ value: id, label: label, color: "#000000" }])
      );
      dispatch(fetchTimeSheet());
    }
  }

  componentWillUnmount() {
    clearTimeout(this.intervalID);
  }

  handleDisplayUploadModal = () => {
    this.props.dispatch(initTimeSheetAttachment());
    this.setState({
      isUploadModalVisible: true
    });
  };

  handleCancel = () => {
    this.setState({
      isUploadModalVisible: false
    });
  };

  handleCloseSideBar = () => {
    this.setState({
      openSideBar: false,
      selectedSideBar: null
    });
  };

  handleSaveTimeSheet = forcedImport => {
    this.setState({ loading: true });
    this.props.dispatch(saveTimeSheet(forcedImport)).then(
      res => {
        this.setState({
          loading: false,
          isUploadModalVisible: false,
          isConfirmationModalVisible: false
        });
        onSuccess(res, {
          title: _("importSuccess"),
          body: _("importTimeSheetSuccess")
        });
        this.props.dispatch(fetchTimeSheet());
      },
      error => {
        this.setState({ loading: false });
        if (error.response.data.errors[0].code === 170017) {
          this.displayConfirmationModal();
        } else {
          onError(this.renderErrorText(error.response.data.errors[0].code));
        }
      }
    );
  };

  displayConfirmationModal = () => {
    this.setState({ isConfirmationModalVisible: true });
  };

  cancelConfirmationModal = () => {
    this.setState({ isConfirmationModalVisible: false });
  };

  renderErrorText = code => {
    switch (code) {
      case 170020:
      case 170021:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incorrectFile")
            }}
          />
        );
      case 170030:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incompatibleModel")
            }}
          />
        );
      case 170031:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("fileSize")
            }}
          />
        );

      default:
        return <span>{_("errorOccured")}</span>;
    }
  };

  handleFilterFormIsVisible = isVisible => {
    this.setState({ filterFormIsVisible: isVisible });
  };

  handleExportTimeSheet = () => {
    const { dispatch } = this.props;
    let { timeSheetData } = this.props;
    dispatch(exportPeriodTimeSheet());
  };

  render() {
    const {
      fetching,
      fetched,
      error,
      timeSheetData: { timeSheet },
      collaborator,
      currentOrganization
    } = this.props;
    let { isConfirmationModalVisible, loading } = this.state;

    return (
      <div>
        {this.state.openSideBar && <div className={styles.sidebar_mask} />}
        {inIframe() === false && (
          <div style={{ marginBottom: "10px" }}>
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        <PageHeader
          header={_("PrestaTs")}
          subHeader={_("subTitleTimeSheet")}
          icon={ICONS.TIME_SHEET_PAGE_ICON}
        >
          {/* <button
            className="btn secondary text-uppercase"
            onClick={() => this.handleDisplayUploadModal()}
          >
            <SvgIcon icon={ICONS.UPLOAD} />
            {_("import")}
          </button> */}
          <button
            className="btn secondary text-uppercase"
            onClick={() => this.handleExportTimeSheet(timeSheet, 2025)}
            style={{ width: "180px" }}
          >
            <img width={"11%"} src={"/img/icons/exportation.svg"} alt={""} />

            {_("Export")}
          </button>
        </PageHeader>

        <div className={styles.resizable}>
          {/***************  TimeSheet sheet viewer body *************/}
          <div>
            <div className="ttp-tab-container">
              <div className="rmodal__center">
                {collaborator && (
                  <TimeSheetFilter
                    customAddOn={this.renderCycleGuide()}
                    filterFormIsVisible={this.handleFilterFormIsVisible}
                    nbResult={timeSheet ? timeSheet.length : 0}
                    label={_("folderNumber")}
                    marginLeft={"0em"}
                    preferences={
                      currentOrganization["authorisation"] &&
                      currentOrganization["authorisation"].preferences
                    }
                    collaborator={collaborator}
                    hideCollaboratorFilter={this.props.hideCollaboratorFilter}
                  />
                )}

                <div>
                  {fetching ? (
                    <div className={styles.ripple_loading}>
                      <img src={"/img/Ripple-1s-150px.svg"} alt="" />
                    </div>
                  ) : (
                    fetched &&
                    !fetching &&
                    (error
                      ? this.renderTimeSheetCallout(error)
                      : this.renderTimeSheet())
                  )}
                </div>
              </div>
              {this.renderBubbles()}
            </div>
          </div>
        </div>
        {this.renderSideBar()}
        <TTPModal
          visible={this.state.isUploadModalVisible}
          footer={null}
          width={700}
        >
          <TimeSheetUploadContent
            onCancel={this.handleCancel}
            loading={this.state.loading}
            onSave={() => this.handleSaveTimeSheet(0)}
          />
        </TTPModal>
        <TTPDialog
          showDialog={isConfirmationModalVisible}
          loading={loading}
          TTPDialog={{
            approvedAction: () => this.handleSaveTimeSheet(1),
            abortAction: this.cancelConfirmationModal,
            message: _("confirmDeleteTasksMessage"),
            icon: <GarbageIcon />,
            proceedBtnLabel: _("yes"),
            abortBtnLabel: _("no"),
            type: DIALOG_TYPES.ALERT,
            title: "deleteTasksTitle"
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.timeSheetTree.tree.fetching,
  fetched: state.timeSheetTree.tree.fetched,
  error: state.timeSheetTree.tree.error,
  combination: state.timeSheet.combination,
  timeSheetData: state.timeSheetTree.tree.timeSheetData,
  erpData: state.erpData.data.items,
  currentOrganization: state.auth.currentOrganization,
  collaborator: state.collaborator.collaborator,
  user: state.auth.user
});

export default connect(mapStateToProps)(TimeSheetTree);



// WEBPACK FOOTER //
// ./src/components/TimeSheet/TimeSheetTree.js